// extracted by mini-css-extract-plugin
export default {"evenTableRow":"styles_evenTableRow__z+SzG","oddTableRow":"styles_oddTableRow__YEhIN"};